module.exports = __webpack_public_path__ + "img/23.3ab140e9.jpg";